export const ROLE_SET_INITIAL_STATE = 'ROLE_SET_INITIAL_STATE';
export const ROLE_FIND_ALL = 'ROLE_FIND_ALL';
export const ROLE_VIEW = 'ROLE_VIEW';
